import {
    FETCH_CATEGORIES_STARTED,
    FETCH_CATEGORIES_SUCCESS,
    FETCH_CATEGORIES_ERROR,
    SET_CURRENT_CATEGORY_ID,
    SET_SUB_CATEGORIES_STATUS,
    SET_MENU_CATEGORY_ID
} from './types';

export const fetchCategoriesStarted = () => ({
    type : FETCH_CATEGORIES_STARTED,
})
export const fetchCategoriesSuccess = (data: any) => ({
    type        : FETCH_CATEGORIES_SUCCESS,
    categories  : data.categories,
    parents     : data.parents
})
export const fetchCategoriesError = (error:any) => ({
    type : FETCH_CATEGORIES_ERROR,
    error: error
})
export const setCurrentCategoryAction = (id: number) => ({
    type : SET_CURRENT_CATEGORY_ID,
    currentCategoryId: id
})
export const setMenuCategoryAction = (categoryId: number) => ({
    type : SET_MENU_CATEGORY_ID,
    categoryId
})
export const setSubCategoriesStatusAction = (open: boolean) => ({
    type : SET_SUB_CATEGORIES_STATUS,
    open: open
})